<app-error-screen-layout [logoAlt]="copy.logoAlt">
  <h1>{{ copy.heading }}</h1>
  <p>{{ copy.body }}</p>
  <img src="assets/images/unicorn.jpg" [alt]="copy.imageAlt" class="error-image" />
  <button type="button" class="home-link" (click)="recover('retry-reload')">{{ copy.retryLink }}</button>
  <button type="button" class="home-link secondary" (click)="recover('go-home')">{{ copy.homeLink }}</button>
</app-error-screen-layout>